import {BrowserRouter, Navigate, Route, Routes} from "react-router-dom";
import {useContext} from "react";
import {AuthContext, AUTHSTATES} from "./AuthProvider";
import {Box, CircularProgress} from "@mui/joy";
import {Dashboard} from "../pages/Dashboard";
import {Page404} from "../pages/Page404";
import {Login} from "../pages/Login";
import {EditGame} from "../pages/EditGame";
import {Experiences} from "../pages/Experiences";
import {Organizations} from "../pages/Organizations";
import {GameFlow} from "../pages/GameFlow";
import {Storage} from "../pages/Storage";
import { GamePlayers } from "../pages/GamePlayers";
import { QrGenerator } from "../pages/QrGenerator";
import { Users } from "../pages/Users";
import { Awards } from "../pages/Awards";
import { LiveMonitorGame } from "../pages/LiveMonitorGame";
import { SendEmail } from "../pages/SendEmail";
import { SendPushNotifications } from "../pages/SendPushNotifications";
import { Settings } from "../pages/Settings";
import { Stickers } from "../pages/Stickers";
import { CalcoloQuotaGc } from "../pages/CalcoloQuotaGc";
import { ExperienceTasks } from "../pages/ExperienceTasks";
import { Preventivi } from "../pages/Preventivi";
import { ExperienceRewards } from "../pages/ExperienceRewards";
import { Translations } from "../pages/Translations";
import { PaymentQuotes } from "../pages/PaymentQuotes";
import { PaymentQuoteEditor } from "../pages/PaymentQuoteEditor";
import { PaymentRecipients } from "../pages/PaymentRecipients";

export function Router() {

    const {authState} = useContext(AuthContext)
    return (
        <>
            {
                authState === AUTHSTATES.UNKNOWN ?
                    <Box sx={{display:"flex", justifyContent:"center", alignItems:"center", width:"100vw", height:"100vh"}}>
                        <CircularProgress />
                    </Box>
                    :
                    <BrowserRouter>
                        <Routes>
                            <Route path="/login" element={authState === AUTHSTATES.LOGGEDIN ? <Navigate to="/" /> : <Login />} />
                            <Route path="/" element={authState === AUTHSTATES.LOGGEDIN ? <Dashboard /> : <Navigate to="/login" />} />
                            <Route path="/game" element={authState === AUTHSTATES.LOGGEDIN ? <Experiences /> : <Navigate to="/login" />} />
                            <Route path="/game/:id" element={authState === AUTHSTATES.LOGGEDIN ? <EditGame /> : <Navigate to="/login" />} />
                            <Route path="/game/flow/:id" element={authState === AUTHSTATES.LOGGEDIN ? <GameFlow /> : <Navigate to="/login" />} />
                            <Route path="/game/tasks/:id" element={authState === AUTHSTATES.LOGGEDIN ? <ExperienceTasks /> : <Navigate to="/login" />} />
                            <Route path="/game/players/:id" element={authState === AUTHSTATES.LOGGEDIN ? <GamePlayers /> : <Navigate to="/login" />} />
                            <Route path="/game/monitor/:id" element={authState === AUTHSTATES.LOGGEDIN ? <LiveMonitorGame /> : <Navigate to="/login" />} />
                            <Route path="/game/rewards/:id" element={authState === AUTHSTATES.LOGGEDIN ? <ExperienceRewards /> : <Navigate to="/login" />} />
                            <Route path="/game/translations/:id" element={authState === AUTHSTATES.LOGGEDIN ? <Translations /> : <Navigate to="/login" />} />
                            <Route path="/translations" element={authState === AUTHSTATES.LOGGEDIN ? <Translations /> : <Navigate to="/login" />} />
                            <Route path="/game/sendNotifications/:id" element={authState === AUTHSTATES.LOGGEDIN ? <SendPushNotifications /> : <Navigate to="/login" />} />
                            <Route path="/game/sendEmail/:id" element={authState === AUTHSTATES.LOGGEDIN ? <SendEmail /> : <Navigate to="/login" />} />
                            <Route path="/organizzazioni" element={authState === AUTHSTATES.LOGGEDIN ? <Organizations /> : <Navigate to="/login" />} />
                            <Route path="/storage" element={authState === AUTHSTATES.LOGGEDIN ? <Storage /> : <Navigate to="/login" />} />
                            <Route path="/qr-generator" element={authState === AUTHSTATES.LOGGEDIN ? <QrGenerator /> : <Navigate to="/login" />} />
                            <Route path="/users" element={authState === AUTHSTATES.LOGGEDIN ? <Users /> : <Navigate to="/login" />} />
                            <Route path="/preventivi" element={authState === AUTHSTATES.LOGGEDIN ? <Preventivi /> : <Navigate to="/login" />} />
                            <Route path="/pagamenti" element={authState === AUTHSTATES.LOGGEDIN ? <PaymentQuotes /> : <Navigate to="/login" />} />
                            <Route path="/pagamenti/destinatari" element={authState === AUTHSTATES.LOGGEDIN ? <PaymentRecipients /> : <Navigate to="/login" />} />
                            <Route path="/pagamenti/nuovo" element={authState === AUTHSTATES.LOGGEDIN ? <PaymentQuoteEditor /> : <Navigate to="/login" />} />
                            <Route path="/pagamenti/:id" element={authState === AUTHSTATES.LOGGEDIN ? <PaymentQuoteEditor /> : <Navigate to="/login" />} />
                            <Route path="/awards" element={authState === AUTHSTATES.LOGGEDIN ? <Awards /> : <Navigate to="/login" />} />
                            <Route path="/settings" element={authState === AUTHSTATES.LOGGEDIN ? <Settings /> : <Navigate to="/login" />} />
                            <Route path="/stickers" element={authState === AUTHSTATES.LOGGEDIN ? <Stickers /> : <Navigate to="/login" />} />
                            <Route path="/calcolo-quota-gc" element={authState === AUTHSTATES.LOGGEDIN ? <CalcoloQuotaGc /> : <Navigate to="/login" />} />
                            <Route path="*" element={<Page404 />} />
                        </Routes>
                    </BrowserRouter>
            }
        </>
    )
}